import React from 'react';
import { connect } from 'react-redux';
import ImmutablePropTypes from 'react-immutable-proptypes';

import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { siteShape } from '@bibliocommons/bc-prop-types';

import { getLinkedLibrariesById } from '../selectors/LibrarySelector';
import AccountSwitcher from '../components/borrowing/sidebar/AccountSwitcher';

export class AccountSwitcherContainer extends BcReactComponent {
  render() {
    return (
      <AccountSwitcher linkedLibrariesById={this.props.linkedLibrariesById} />
    );
  }
}

const mapStateToProps = (state) => ({
  linkedLibrariesById: getLinkedLibrariesById(state)
});

AccountSwitcherContainer.propTypes = {
  linkedLibrariesById: ImmutablePropTypes.mapOf(siteShape)
};

export default connect(mapStateToProps)(AccountSwitcherContainer);



// WEBPACK FOOTER //
// ./app/containers/AccountSwitcherContainer.jsx